import React from 'react';
import { Link } from 'react-router-dom';

const WA_NUMBER = '573013354020';
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=Hola%20DHING%2C%20estoy%20interesado%20en%20DH%20Assembly%20para%20mi%20conjunto%20residencial`;
const DHING_URL = 'https://www.dhing.com.co/';

export const LandingFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-200 py-12 lg:py-16 text-slate-600 text-sm relative overflow-hidden">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {/* Col 1: Brand */}
          <div>
            <a
              href={DHING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <h4 className="font-bold text-xl text-slate-900 tracking-tight mb-3">
                DH<span className="text-blue-600">ING</span>
              </h4>
            </a>
            <p className="text-xs text-slate-500 leading-relaxed mb-4">
              Desarrollo de software profesional y soluciones tecnológicas a medida para potenciar la gestión y eficiencia organizacional.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={DHING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-700 hover:bg-[#2AFF00] hover:text-black hover:border-[#2AFF00] transition-all duration-300"
                aria-label="Visitar DHING"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                  <path d="M2 12h20" />
                </svg>
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-700 hover:bg-emerald-500 hover:text-white hover:border-emerald-500 transition-all duration-300"
                aria-label="Contactar por WhatsApp"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/dhing.com.co"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-700 hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all duration-300"
                aria-label="Síguenos en Instagram"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/jesus-david-diaz-hernandez/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-700 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Col 2: El Proyecto */}
          <div>
            <h5 className="font-bold text-xs uppercase tracking-wider text-slate-900 mb-4">El Proyecto</h5>
            <p className="text-xs text-slate-500 leading-relaxed">
              <strong>DH Assembly</strong> es una solución especializada orientada a garantizar transparencia, orden y absoluta validez jurídica en las asambleas de copropietarios bajo el marco legal vigente.
            </p>
          </div>

          {/* Col 3: Legal & Soporte */}
          <div>
            <h5 className="font-bold text-xs uppercase tracking-wider text-slate-900 mb-4">Legal & Soporte</h5>
            <ul className="space-y-2 text-xs">
              <li>
                <Link to="/legal/terms" className="hover:text-blue-600 transition-colors">
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="hover:text-blue-600 transition-colors">
                  Políticas de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/manual" className="hover:text-blue-600 transition-colors">
                  Manual de Uso
                </Link>
              </li>
              <li>
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">
                  Soporte Técnico
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Row */}
        <div className="pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>&copy; 2019-{currentYear} <strong>DHING ®</strong>. Todos los derechos reservados.</p>
          <p className="flex items-center gap-1">
            Diseñado y desarrollado con{' '}
            <span className="inline-flex translate-y-[1px] items-center">
              <span className="sr-only">amor</span>
              <svg
                className="h-4 w-4 text-red-500"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M12 21s-7.2-4.9-9.6-8.5C.6 10.1 1.1 7.1 3.1 5.4c1.7-1.4 4.2-1.2 5.8.4L12 9l3.1-3.2c1.6-1.6 4.1-1.8 5.8-.4 2 1.7 2.5 4.7.7 7.1C19.2 16.1 12 21 12 21z" />
              </svg>
            </span>{' '}
            en Colombia.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
